import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { css } from '@emotion/react'
import { Link } from 'react-router-dom'
import { Layout, Input, Space, Modal, Form } from 'antd';
import { SearchOutlined, SwapOutlined, PlusCircleOutlined } from '@ant-design/icons';
import MainMenu from './MainMenu/MainMenu.jsx';
import favicon from '/favicon.png';
import { useUser, setUser } from '@/biz/user.mjs'
import useHTTP from "@/hooks/useHTTP.mjs";
import runAsync from "@/script/runAsync.mjs";
import openWindow from '@/script/openWindow.mjs';
import SelectProjectDialog from '@/pages/MainPage/dialogs/SelectProjectDialog';
import AddProjectDialog from '@/pages/MainPage/dialogs/AddProjectDialog';
import useCurrentProject from '@/biz/useCurrentProject.mjs'
import MenuAi from './MenuAi/MenuAi.jsx'
import {Alert, useOpenModal} from '@/components/Modal/index.mjs';
import TeamData from '@/pages/MainPage/datas/TeamData'

const cssTitle = css({
    fontSize: 20,
    color: '#fff',
    padding: '0 15px',
    display: 'flex',
    alignItems: 'center'
})

const cssLink = css({
    fontWeight: 'bold',
    color: '#fff',
    display: 'flex',
    flexShrink: 0,
    alignItems: 'center'
})

const cssLogo = css({
    height: 22,
    marginRight: 8,
})

const cssProject = css({
    color: '#fff',
    fontSize: 16,
    marginLeft: 20,
})

const cssProjectLink = css({
    color: '#fff',
    fontSize: 16,
    marginLeft: 10,
})

const MainTitle = () => {
    const navigate = useNavigate();
    const http = useHTTP();
    const user = useUser()
    const [, setCurrentProject] = useCurrentProject()
    const openModal = useOpenModal();
    const [visible, setVisible] = useState(false);
    const [visibleAdd, setVisibleAdd] = useState(false);

    // 注册团队号
    const [teamRegVisible, setTeamRegVisible] = useState(false);
    const [teamRegForm] = Form.useForm();

    useEffect(() => {
        if (teamRegVisible) {
            teamRegForm.resetFields();
        }
    }, [teamRegVisible]);

    const doRegisterTeam = () => {
        teamRegForm.validateFields().then(async values => {
            await runAsync(
                async () => http.post('/tmteams', values),
                {
                    error: { content: (err) => `注册团队号失败: ${err.message}` },
                    loading: { show: false },
                    success: { show: true },
                }
            );
            setTeamRegVisible(false);
            openWindow('/TeamList');
        });
    };

    const handleAddProject = async () => {
        await runAsync(
            async () => {
                try {
                    await http.post('/checkAddPrjCondition');
                    setVisibleAdd(true);
                } catch (err) {
                    if ('01010120' === err.code) {
                        const ac = new AbortController()

                        await openModal(
                            <Alert>
                                <p>您需要加入一个团队号才能新建项目，可以选择以下方案：</p>
                                <p>方案1：您可以联系某一个团队号的管理员，由他邀请您加入团队号，再继续新建项目。</p>
                                <p>方案2：您可以自己<a onClick={() => {ac.abort(); setTeamRegVisible(true)}}>注册团队号</a>，经过平台审核之后，再继续新建项目。</p>
                            </Alert>,

                            {signal: ac.signal}
                        )
                    } else {
                        throw err;
                    }
                }
            },
            {
                action: '检查新建项目条件',
                loading: { show: false },
                success: { show: false },
            }
        );
    };

    const callPrj = async (value) => {
        if (value) {
            try {
                const { pkid, sVer } = value

                await runAsync(
                    () => setCurrentProject(pkid, sVer),
                    { action: '设置当前项目' }
                )

                // 打开模型总图
                openWindow(`/SaList?prjId=${pkid}&sVer=${sVer}`)

                // if (location.pathname.includes('/SoftwareMap')) {
                //     // navigate('/');
                //     navigation.navigate('/');
                // }
            } catch (err) {
                console.log(err);
            }
        }
    }

    const linkPrj = () => {
        openWindow('/ProjectDetail', { prjId: user?.currPrjId, prjNo: user?.currPrjNo });
    }

    const openSa = () => {
        const prjId = user?.currPrjId;
        const sVer = user?.currPrjSver;

        if (prjId && sVer) {
            openWindow(`/SaList?prjId=${prjId}&sVer=${sVer}`);
        }
    }

    return (
        <div css={cssTitle}>
            <Link
                css={cssLink}
                reloadDocument
                to="/"
                title={'进入工作台'}
            >
                <img
                    css={cssLogo}
                    alt="logo"
                    src={favicon}
                />
                爱捷思<sup style={{fontSize: '.5em', marginRight: '1em'}}>&reg;</sup>| 软件逻辑地图
            </Link>

            <a css={cssProject} onClick={openSa} title={"打开模型总图"}>{user?.currPrjNo}[{user?.currPrjSver ?? '当前项目'}]</a>

            <a css={cssProjectLink} onClick={() => setVisible(true)} title={"切换当前项目"}><SwapOutlined /></a>

            <span title={"新建项目"} onClick={handleAddProject} style={{ marginLeft: '10px' }}><PlusCircleOutlined /></span>

            {
                user?.currPrjNo &&
                <Input
                    allowClear
                    prefix={<SearchOutlined />}
                    placeholder={'搜索模件'}
                    style={{ width: 200, marginLeft: '20px', borderRadius: '16px' }}
                    onPressEnter={(e) => openWindow('/PrjSearch', { keyword: e.target.value })}
                />
            }

            <SelectProjectDialog visible={visible} setVisible={setVisible} onCall={callPrj} prjStsCodes={['RLS']} />
            <AddProjectDialog visible={visibleAdd} setVisible={setVisibleAdd} />

            <Modal title="注册团队号" okText="保存" open={teamRegVisible} onOk={doRegisterTeam} onCancel={() => setTeamRegVisible(false)}>
                <Form form={teamRegForm} onFinish={doRegisterTeam} layout="vertical">
                    <TeamData.teamNo />
                    <TeamData.teamName />
                    <TeamData.teamDesc />
                </Form>
            </Modal>
        </div>
    );
};

const cssHeader = css({
    display: 'grid',
    gridTemplateColumns: 'auto auto 1fr',
    alignItems: 'center',
    height: 64,
    color: '#000000d9',
    backgroundColor: '#001529',
    overflow: 'hidden',
})

const cssMainMenu = css({
    flexGrow: 1,
    justifyContent: 'flex-end',
})

export default function MainHeader(props) {
    return (
        <div
            css={cssHeader}
            {...props}
        >
            <MainTitle />
            <MenuAi />
            <MainMenu css={cssMainMenu} />
        </div>
    )
}
